import { Localized } from "@fluent/react";
import { UrsStatus } from "./UrsSlice";


export const UrsStatusLabel = ({ status }: { status: UrsStatus | undefined}) => {
    switch (status) {
        case "N":
            return <Localized id="urs-status-n">
                <span>Nowy</span>
            </Localized>        
        case "I":
            return <Localized id="urs-status-i">
                <span>Do zatwierdzenia</span>
            </Localized>
        case "C":
            return <Localized id="urs-status-c">
                <span>Korekta</span>
            </Localized>
        case "A":
            return <Localized id="urs-status-a">
                <span>Zatwierdzony</span>
            </Localized>
        case "F":
            return <Localized id="urs-status-f">
                <span>Zakończony</span>
            </Localized>
        case "P":
            return <Localized id="urs-status-p">
                <span>Opublikowany</span>
            </Localized>
        case "O":
            return <Localized id="urs-status-o">
                <span>Opiniowanie</span>
            </Localized>
        case "D":
            return <Localized id="urs-status-d">
                <span>Zaopiniowany</span>
            </Localized>
        case "E":
            return <Localized id="urs-status-e">
                <span>Zaimportowany</span>
            </Localized>
        default:
            return <span>{status}</span>
    }
}